var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-template a4"},[_c(_vm.template,{tag:"component",staticClass:"a4",attrs:{"client":_vm.client,"invoice":_vm.invoice,"user":_vm.user,"company":_vm.company}},[_c('img',{staticClass:"invoice-image-template",attrs:{"src":_vm.url}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }